class NotificationPanelController {
    constructor($scope, shopperService, loginService, gtm, sessionStorage) {
        this.$scope = $scope;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.gtm = gtm;
        this.sessionStorage = sessionStorage;

        this.shouldDisplayDynamicSuburbDialog = false;
    }

    $onInit() {
        const sessionStorageKey = 'pendingDynamicSuburbsPopup';

        this.$scope.$on('login:success', () => {
            this.sessionStorage.set(sessionStorageKey, true);
        });

        if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
            this.showDynamicSuburbsDialog();
        }
    }

    showDynamicSuburbsDialog() {
        this.shouldDisplayDynamicSuburbDialog = !this.shopperService.IsGuest
            && this.shopperService.ShouldShowDeliveryWindowDialog
            && this.loginService.loginContext !== 'checkout';

        if (this.shouldDisplayDynamicSuburbDialog) {
            this.gtm.push({ event: 'dynamic suburbs popup presented' });
        }
    }
}

NotificationPanelController.$inject = ['$scope', 'ShopperService', 'LoginService', 'GtmService', 'SessionStorageWrapper'];

const notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: require('./notification-panel.component.html').trim(),
};

module.exports = {
    NotificationPanelController,
    notificationPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/notificationpanel/notification-panel.component.js